import React from "react";
import Moment from "react-moment";
import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import TimeTotalSelected from "../helpers/TimeTotalSelected.jsx";
import zoneConverter from "../helpers/zoneConverter.jsx";

const CardHeaderImportDataCalendar = ({ item, selectedEntries }) => {
    const formatDateWithLabel = (date) => {
        const today = new Date();
        const yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);

        if (date.toDateString() === today.toDateString()) {
            return "Today";
        } else if (date.toDateString() === yesterday.toDateString()) {
            return "Yesterday";
        } else {
            return <Moment format="ddd, MMM D" tz={global.config.getTimeZone()}>{date}</Moment>;
        }
    };

    return (
        <Card.Header>
            <Row className="card-header-sec">
                <Col className="card-header-date">
                    {formatDateWithLabel(new Date(item[0]))}
                </Col>
                <div className="separation-head"></div>
                <Col className="card-timer">
                    {/* Pass selectedEntries to TimeTotalSelected for immediate updates when checkboxes change */}
                    <TimeTotalSelected item={item} selectedEntries={selectedEntries} />
                </Col>
            </Row>
        </Card.Header>
    );
};

export default CardHeaderImportDataCalendar;

